import React, { useState } from "react";
import SectionHeading from "../SectionHeading/SectionHeading";

const AccountDeletion = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",

    reason: "",
  });
  const [errors, setErrors] = useState({});

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    let newErrors = {};
    if (formData.name.trim().length < 3)
      newErrors.name = "Name must be at least 3 characters long.";
    if (!/^[0-9]{10}$/.test(formData.phone))
      newErrors.phone = "Enter a valid 10-digit phone number.";
    if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)
    )
      newErrors.email = "Enter a valid email address.";
    if (formData.reason.trim().length < 5)
      newErrors.reason =
        "Reason for account deletion must be at least 5 characters long.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    const formData = new FormData(event.target);
    formData.append("access_key", "7052490f-8fec-424b-b8f2-eb83840eb06e");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      setFormData({
        name: "",
        phone: "",
        email: "",

        reason: "",
      });
      setErrors({});
    }
    setLoading(false);
  };

  return (
    <section className="st-shape-wrap" id="account-deletion">
      <SectionHeading
        title="Request Account Deletion"
        subTitle="Please fill out the form below to request the deletion of your account."
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <form
              onSubmit={onSubmit}
              className="row st-contact-form st-type1"
              method="post"
              id="account-deletion-form"
            >
              <input
                type="hidden"
                name="subject"
                value="Account Deletion Request"
              ></input>
              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Full Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    onChange={handleInputChange}
                    value={formData.name}
                  />
                  {errors.name && <p className="error-text">{errors.name}</p>}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Phone</label>
                  <input
                    type="text"
                    name="phone"
                    placeholder="Phone"
                    onChange={handleInputChange}
                    value={formData.phone}
                  />
                  {errors.phone && <p className="error-text">{errors.phone}</p>}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    onChange={handleInputChange}
                    value={formData.email}
                  />
                  {errors.email && <p className="error-text">{errors.email}</p>}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Reason for Deletion</label>
                  <input
                    type="text"
                    name="reason"
                    placeholder="Reason for account deletion"
                    onChange={handleInputChange}
                    value={formData.reason}
                  />
                  {errors.reason && (
                    <p className="error-text">{errors.reason}</p>
                  )}
                </div>
              </div>
              <div className="col-lg-12 text-center">
                <button
                  className="st-btn st-style1 st-color1 st-size-medium"
                  type="submit"
                  id="submit"
                >
                  {loading ? "Sending..." : "Request Deletion"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccountDeletion;
